var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-info-col-type',{attrs:{"label":_vm.label,"data":_vm.date,"col-class":_vm.colClass}},[_vm._v("\n  "+_vm._s(_vm._f("datetime")(_vm.date))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }